/****
 * Application entry point responsible for initializing authentication,
 * configuring providers, and rendering the React application.
 *
 * Loads MSAL authentication settings, initializes Microsoft sign-in,
 * processes authentication redirects, and wraps the application with
 * Redux and MSAL providers before mounting it to the DOM.
 */
import { MsalProvider } from "@azure/msal-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import { getMsalInstance, initAuth } from "./auth/bootstrapMsal";
import { store } from "./store";

async function start() {
  // 2. Load MSAL config from backend
  await initAuth();
  const msalInstance = getMsalInstance();

  // 3. Initialize MSAL
  await msalInstance.initialize();

  // 4. Handle login redirect
  await msalInstance.handleRedirectPromise();

  // 5. Render App
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <Provider store={store}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </Provider>
    </React.StrictMode>
  );
}

void start();
